import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchAllTrades,
  fetchTradesByStatus,
  selectTrade,
  fetchCompletedTrades,
  updateTradeType,
} from "store/slices/trade.slice";
import orderBy from "lodash/orderBy";

const useTradeHistory = (pagination = {}) => {
  const dispatch = useDispatch();
  const {
    trades: { type, data, status, count },
  } = useSelector(selectTrade);

  /*eslint-disable */
  const getTrades = useCallback(() => {
    if (type === "all") dispatch(fetchAllTrades(pagination));
    if (type === "completed") dispatch(fetchCompletedTrades(pagination));
    if (type !== "all" && type !== "completed")
      dispatch(fetchTradesByStatus({ type, ...pagination }));
  }, [type, dispatch, pagination?.page]);

  useEffect(() => getTrades(), [getTrades]);
  /*eslint-enable */

  const updateType = (type) => dispatch(updateTradeType(type));

  return {
    count,
    type,
    data: orderBy(data, ["createdAt"], ["desc"]),
    status,
    updateType,
    refetch: getTrades,
  };
};

export default useTradeHistory;
